<template>
	<div class="container">
		<div class="banner">
			<el-carousel :height="carouselHeight + 'px'">
				<el-carousel-item v-for="(item, index) in pageData[0]" :key="index">
					<el-image fit="cover" :style="{width: '100%', height: carouselHeight + 'px'}"
						:src="$img(item.image)" />
				</el-carousel-item>
			</el-carousel>
		</div>

		<div class="classify">
			<div class="classify-title">
				探索我们的产品
			</div>
			<div class="classify-label">
				户外保险找{{ $getter('setting').value10 }}<!-- 6W企业用户的选择 -->
			</div>
			<div class="classify-list">
				<div class="classify-item" @click="$navto(item.url)" v-for="(item, index) in pageData[1]" :key="index">
					<div class="classify-info">
						<div class="classify-icon">
							<el-image fit="cover" :src="$img(item.image)" />
						</div>
						<div class="classify-name">
							{{ item.title }}
						</div>
					</div>
					<div class="classify-item-more">
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
			</div>

			<div class="classify-more">
				<el-button @click="$navto('/insure/index')" type="primary" round>查看更多<i
						class="el-icon-arrow-right el-icon--right"></i></el-button>
			</div>
		</div>

		<div class="product">
			<div class="product-header">
				<div class="product-header-left">
					<div class="product-header-title">
						热门产品
					</div>
					<div class="product-header-label">
						{{ $getter('setting').value10 }}多种产品任您选择
					</div>
				</div>
				<div class="product-header-right">
					<el-button @click="$navto('/insure/index')" type="primary" round>查看更多<i
							class="el-icon-arrow-right el-icon--right"></i></el-button>
				</div>
			</div>

			<div class="product-list">
				<div class="product-item" v-for="(item, index) in list" :key="index"
					@click="$navto('/insure/detail?id=' + item.id)">
					<div class="product-image">
						<el-image fit="cover" :src="$img(item.main_image)" />
					</div>
					<div class="product-info">
						<div class="product-name">
							{{ item.name }}
						</div>
						<div class="product-explain">
							{{ item.intro }}
						</div>
						<div class="product-label" v-for="(explain, explainIndex) in item.explain" :key="explainIndex">
							<el-image :src="require('@/../static/icon/shield.png')" />
							<div>
								{{ explain.name }}
							</div>
						</div>
						<div class="product-bottom">
							<div class="product-price">
								{{ item.price }}<span>元/起</span>
							</div>
							<div class="product-btn">
								了解详情
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="about">
			<div class="about-title">
				关于{{ $getter('setting').value10 }}
			</div>
			<div class="about-label">
				{{ $getter('setting').value10 }}您的户外保险小助手
			</div>

			<div class="about-info" v-if="pageData[2]">
				<div class="about-image">
					<el-image fit="cover" :src="$img(pageData[2][0].image)" />
				</div>
				<div class="about-content">
					<div class="about-info-title">
						{{ pageData[2][0].title }}
					</div>
					<div class="about-info-content">
						{{ pageData[2][0].content }}
					</div>
				</div>
			</div>
		</div>

		<div class="cooperation">
			<div class="cooperation-title">
				合作伙伴
			</div>
			<div class="cooperation-label">
				{{ $getter('setting').value10 }}期待与您的合作
			</div>
			<div class="cooperation-list">
				<div class="cooperation-item" v-for="(item, index) in pageData[3]" :key="index">
					<el-image fit="contain" :src="$img(item.image)" />
				</div>
			</div>
		</div>

		<mainFooter />
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';
	export default {
		components: {
			mainFooter,
		},
		data() {
			return {
				pageData: [],
				form: {
					_order: 'sort',
					_isreverse: 1,
					group_ids: [7],
				},
				list: [],
				carouselHeight: 600, // 默认高度
			}
		},
		mounted() {
			this.getPageData();
			this.ActionList();
			this.updateCarouselHeight();
			window.addEventListener('resize', this.updateCarouselHeight);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateCarouselHeight);
		},
		methods: {
			updateCarouselHeight() {
				// 根据屏幕宽度动态计算轮播图高度
				const screenWidth = window.innerWidth;
				if (screenWidth <= 1280) {
					this.carouselHeight = 450;
				} else if (screenWidth <= 1440) {
					this.carouselHeight = 500;
				} else {
					this.carouselHeight = 600;
				}
			},
			ActionList() {
				this.$get('app-goods', this.form).then(res => {
					if (res.data.length > 0) {
						this.list = this.list.concat(res.data);
					}
				}).catch(err => {
					this.$message.error(err);
				})
			},
			getPageData() {
				this.$get('app-page-design/2').then(res => {
					this.pageData = res.data.content || [];
				}).catch(err => {
					this.$notify.error({
						message: err || '网络请求错误'
					});
				});
			},
		},
	}
</script>

<style lang="scss">
	/* 禁止整个页面在轮播图区域滚动 */
	body,
	html {
		overflow-x: hidden;
	}

	.container {
		width: 100%;
		background-color: #F7F7F7;

		.banner {
			width: 100%;
			background-color: #fff;
			/* 完全禁止滚动 */
			overflow: hidden !important;
			position: relative;

			.el-carousel {
				/* 完全禁止滚动 */
				overflow: hidden !important;
				position: relative;

				.el-carousel__container {
					/* 完全禁止滚动 */
					overflow: hidden !important;
					position: relative;
				}

				.el-carousel__item {
					/* 确保图片不会超出 */
					overflow: hidden !important;

					.el-image {
						/* 确保图片不会超出 */
						display: block;
					}
				}
			}
		}

		.classify {
			padding: 60px 16%;
			background-color: #fff;

			/* 笔记本适配 */
			@media (max-width: 1440px) {
				padding: 50px 12%;
			}

			@media (max-width: 1280px) {
				padding: 40px 8%;
			}

			.classify-title {
				text-align: center;
				color: #333333;
				font-size: 28px;
				font-weight: bold;

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					font-size: 26px;
				}

				@media (max-width: 1280px) {
					font-size: 24px;
				}
			}

			.classify-label {
				text-align: center;
				color: #666666;
				font-size: 18px;
				margin-top: 10px;

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					font-size: 17px;
				}

				@media (max-width: 1280px) {
					font-size: 16px;
				}
			}

			.classify-list {
				width: 100%;
				gap: 20px;
				display: flex;
				flex-wrap: wrap;
				margin-top: 30px;

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					gap: 18px;
					margin-top: 25px;
				}

				@media (max-width: 1280px) {
					gap: 15px;
					margin-top: 20px;
				}

				.classify-item {
					display: flex;
					align-items: center;
					border: 1px solid #2280FD;
					padding: 10px;
					border-radius: 10px;
					width: calc(25% - 15px);
					cursor: pointer;
					justify-content: space-between;

					/* 笔记本适配 */
					@media (max-width: 1440px) {
						width: calc(25% - 13.5px);
						padding: 9px;
					}

					@media (max-width: 1280px) {
						width: calc(25% - 11.25px);
						padding: 8px;
					}

					.classify-info {
						display: flex;
						align-items: center;

						.classify-icon {
							padding: 6px;
							background-color: #F1FAFF;
							border-radius: 50px;
							width: 40px;
							height: 40px;
							display: flex;
							justify-content: center;
							align-items: center;

							/* 笔记本适配 */
							@media (max-width: 1440px) {
								width: 38px;
								height: 38px;
							}

							@media (max-width: 1280px) {
								width: 36px;
								height: 36px;
							}

							.el-image {
								width: 30px;
								height: 30px;

								/* 笔记本适配 */
								@media (max-width: 1440px) {
									width: 28px;
									height: 28px;
								}

								@media (max-width: 1280px) {
									width: 26px;
									height: 26px;
								}
							}
						}

						.classify-name {
							color: #333333;
							font-size: 18px;
							margin-left: 15px;

							/* 笔记本适配 */
							@media (max-width: 1440px) {
								font-size: 17px;
								margin-left: 12px;
							}

							@media (max-width: 1280px) {
								font-size: 16px;
								margin-left: 10px;
							}
						}
					}

					.classify-item-more {
						width: 25px;
						height: 25px;
						display: flex;
						justify-content: center;
						align-items: center;
						background-color: #F1FAFF;
						border-radius: 50px;

						/* 笔记本适配 */
						@media (max-width: 1440px) {
							width: 23px;
							height: 23px;
						}

						@media (max-width: 1280px) {
							width: 22px;
							height: 22px;
						}

						i {
							font-size: 15px;
							color: #2280FD;

							/* 笔记本适配 */
							@media (max-width: 1440px) {
								font-size: 14px;
							}

							@media (max-width: 1280px) {
								font-size: 13px;
							}
						}
					}
				}
			}

			.classify-more {
				display: flex;
				justify-content: center;
				margin-top: 30px;

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					margin-top: 25px;
				}

				@media (max-width: 1280px) {
					margin-top: 20px;
				}

				.el-button {
					background-color: #2280FD;
				}
			}
		}

		.product {
			padding: 60px 16%;
			background-color: #F4F6FA;

			/* 笔记本适配 */
			@media (max-width: 1440px) {
				padding: 50px 12%;
			}

			@media (max-width: 1280px) {
				padding: 40px 8%;
			}

			.product-header {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.product-header-left {
					.product-header-title {
						font-weight: bold;
						color: #000000;
						font-size: 28px;

						/* 笔记本适配 */
						@media (max-width: 1440px) {
							font-size: 26px;
						}

						@media (max-width: 1280px) {
							font-size: 24px;
						}
					}

					.product-header-label {
						color: #666666;
						font-size: 18px;
						margin-top: 10px;

						/* 笔记本适配 */
						@media (max-width: 1440px) {
							font-size: 17px;
						}

						@media (max-width: 1280px) {
							font-size: 16px;
						}
					}
				}

				.product-header-right {
					.el-button {
						background-color: #2280FD;
					}
				}
			}

			.product-list {
				margin-top: 20px;
				display: flex;
				gap: 20px;
				flex-wrap: wrap;

				@media (min-width: 1024px) and (max-width: 1440px) {
					gap: 15px;
					margin-top: 18px;
				}

				@media (max-width: 1023px) and (min-width: 768px) {
					gap: 12px;
					margin-top: 15px;
				}

				@media (max-width: 767px) {
					gap: 10px;
					margin-top: 12px;
				}

				.product-item {
					display: flex;
					width: calc(50% - 10px);
					background-color: #fff;
					padding: 12px;
					border-radius: 15px;
					cursor: pointer;
					transition: all 0.3s ease;
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
					box-sizing: border-box;
					overflow: hidden;

					@media (min-width: 1024px) and (max-width: 1440px) {
						width: calc(50% - 7.5px);
						padding: 10px;
						border-radius: 12px;
					}

					@media (max-width: 1023px) and (min-width: 768px) {
						width: calc(50% - 6px);
						padding: 8px;
						border-radius: 10px;
					}

					@media (max-width: 767px) {
						width: 100%;
						padding: 10px;
						border-radius: 8px;
						flex-direction: column;
					}

					&:hover {
						transform: translateY(-5px);
						box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
					}

					.product-image {
						.el-image {
							border-radius: 10px;
							width: 200px;
							height: 230px;
							max-width: 100%;
							object-fit: cover;

							@media (min-width: 1024px) and (max-width: 1440px) {
								width: 160px;
								height: 180px;
								border-radius: 8px;
							}

							@media (max-width: 1023px) and (min-width: 768px) {
								width: 130px;
								height: 150px;
								border-radius: 6px;
							}

							@media (max-width: 767px) {
								width: 100%;
								height: 160px;
								border-radius: 6px;
							}
						}

						width: 40%;
						flex-shrink: 0;
						display: flex;
						justify-content: center;
						align-items: flex-start;

						@media (min-width: 1024px) and (max-width: 1440px) {
							width: 160px;
						}

						@media (max-width: 1023px) and (min-width: 768px) {
							width: 130px;
						}

						@media (max-width: 767px) {
							width: 100%;
							margin-bottom: 8px;
						}
					}

					.product-info {
						width: 58%;
						flex: 1;
						min-width: 0;
						padding-left: 15px;
						box-sizing: border-box;

						@media (min-width: 1024px) and (max-width: 1440px) {
							width: calc(100% - 160px);
							padding-left: 15px;
						}

						@media (max-width: 1023px) and (min-width: 768px) {
							width: calc(100% - 130px);
							padding-left: 12px;
						}

						@media (max-width: 767px) {
							width: 100%;
							padding-left: 0;
							padding-top: 10px;
						}

						.product-name {
							color: #333333;
							font-weight: bold;
							font-size: 18px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;

							@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 16px;
							}

							@media (max-width: 1023px) and (min-width: 768px) {
								font-size: 15px;
							}

							@media (max-width: 767px) {
								font-size: 16px;
							}
						}

						.product-explain {
							color: #999999;
							font-size: 14px;
							margin-top: 5px;

							/* 多行文本溢出隐藏 */
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							overflow: hidden;
							text-overflow: ellipsis;
							line-height: 1.4;

							/* 确保在移动端也能正确显示 */
							min-height: 2.8em;

							@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 13px;
								margin-top: 4px;
								line-height: 1.3;
								min-height: 2.6em;
							}

							@media (max-width: 1023px) and (min-width: 768px) {
								font-size: 12px;
								margin-top: 3px;
								line-height: 1.3;
								min-height: 2.6em;
							}

							@media (max-width: 767px) {
								font-size: 13px;
								margin-top: 4px;
								line-height: 1.3;
								min-height: 2.6em;
							}
						}

						.product-label {
							display: flex;
							align-items: center;
							gap: 5px;
							font-size: 16px;
							color: #666666;
							margin-top: 10px;

							@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 14px;
								margin-top: 8px;
								gap: 4px;
							}

							@media (max-width: 1023px) and (min-width: 768px) {
								font-size: 13px;
								margin-top: 6px;
								gap: 3px;
							}

							@media (max-width: 767px) {
								font-size: 14px;
								margin-top: 8px;
								gap: 4px;
							}

							.el-image {
								width: 15px;
								height: 15px;

								@media (min-width: 1024px) and (max-width: 1440px) {
									width: 13px;
									height: 13px;
								}

								@media (max-width: 1023px) and (min-width: 768px) {
									width: 12px;
									height: 12px;
								}

								@media (max-width: 767px) {
									width: 13px;
									height: 13px;
								}
							}

							div {
								width: 100%;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}
						}

						.product-bottom {
							display: flex;
							justify-content: space-between;
							align-items: center;
							margin-top: 30px;
							margin-left: 20px;

							@media (min-width: 1024px) and (max-width: 1440px) {
								margin-top: 20px;
								margin-left: 15px;
							}

							@media (max-width: 1023px) and (min-width: 768px) {
								margin-top: 15px;
								margin-left: 10px;
							}

							@media (max-width: 767px) {
								margin-top: 15px;
								margin-left: 0;
							}

							.product-price {
								color: #FF2B2B;
								font-weight: bold;
								font-size: 32px;

								@media (min-width: 1024px) and (max-width: 1440px) {
									font-size: 26px;
								}

								@media (max-width: 1023px) and (min-width: 768px) {
									font-size: 22px;
								}

								@media (max-width: 767px) {
									font-size: 24px;
								}

								span {
									font-weight: 500;
									font-size: 20px;

									@media (min-width: 1024px) and (max-width: 1440px) {
										font-size: 16px;
									}

									@media (max-width: 1023px) and (min-width: 768px) {
										font-size: 14px;
									}

									@media (max-width: 767px) {
										font-size: 16px;
									}
								}
							}

							.product-btn {
								background-color: #2280FD;
								width: 110px;
								line-height: 40px;
								border-radius: 50px;
								color: #fff;
								text-align: center;
								transition: all 0.3s ease;

								@media (min-width: 1024px) and (max-width: 1440px) {
									width: 95px;
									line-height: 34px;
									font-size: 14px;
								}

								@media (max-width: 1023px) and (min-width: 768px) {
									width: 85px;
									line-height: 30px;
									font-size: 13px;
									border-radius: 40px;
								}

								@media (max-width: 767px) {
									width: 90px;
									line-height: 32px;
									font-size: 14px;
								}

								&:hover {
									background-color: #1a6fd8;
								}
							}
						}
					}
				}
			}
		}

		.about {
			background-color: #fff;
			padding: 60px 80px 30px;

			/* 笔记本适配 */
			@media (max-width: 1440px) {
				padding: 50px 60px 25px;
			}

			@media (max-width: 1280px) {
				padding: 40px 40px 20px;
			}

			.about-title {
				text-align: center;
				color: #333333;
				font-size: 28px;
				font-weight: bold;

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					font-size: 26px;
				}

				@media (max-width: 1280px) {
					font-size: 24px;
				}
			}

			.about-label {
				text-align: center;
				font-size: 18px;
				color: #666666;
				margin-top: 10px;

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					font-size: 17px;
				}

				@media (max-width: 1280px) {
					font-size: 16px;
				}
			}

			.about-info {
				display: flex;
				margin-top: 40px;
				align-items: center;

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					margin-top: 35px;
				}

				@media (max-width: 1280px) {
					margin-top: 30px;
				}

				.about-image {
					.el-image {
						width: 700px;
						height: 400px;

						/* 笔记本适配 */
						@media (max-width: 1440px) {
							width: 600px;
							height: 350px;
						}

						@media (max-width: 1280px) {
							width: 500px;
							height: 300px;
						}
					}
				}

				.about-content {
					margin-left: 100px;
					width: 35%;

					/* 笔记本适配 */
					@media (max-width: 1440px) {
						margin-left: 70px;
						width: 38%;
					}

					@media (max-width: 1280px) {
						margin-left: 60px;
						width: 40%;
					}

					.about-info-title {
						color: #333333;
						font-size: 24px;

						/* 笔记本适配 */
						@media (max-width: 1440px) {
							font-size: 22px;
						}

						@media (max-width: 1280px) {
							font-size: 20px;
						}
					}

					.about-info-content {
						margin-top: 40px;
						color: #666666;
						font-size: 16px;

						/* 笔记本适配 */
						@media (max-width: 1440px) {
							margin-top: 35px;
							font-size: 15px;
						}

						@media (max-width: 1280px) {
							margin-top: 30px;
							font-size: 14px;
						}
					}
				}
			}
		}

		.cooperation {
			padding: 60px 16%;

			/* 笔记本适配 */
			@media (max-width: 1440px) {
				padding: 50px 12%;
			}

			@media (max-width: 1280px) {
				padding: 40px 8%;
			}

			.cooperation-title {
				text-align: center;
				color: #333333;
				font-size: 28px;
				font-weight: bold;

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					font-size: 26px;
				}

				@media (max-width: 1280px) {
					font-size: 24px;
				}
			}

			.cooperation-label {
				text-align: center;
				font-size: 18px;
				color: #666666;
				margin-top: 10px;

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					font-size: 17px;
				}

				@media (max-width: 1280px) {
					font-size: 16px;
				}
			}

			.cooperation-list {
				width: 100%;
				gap: 20px;
				display: flex;
				flex-wrap: wrap;
				margin-top: 30px;

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					gap: 18px;
					margin-top: 25px;
				}

				@media (max-width: 1280px) {
					gap: 15px;
					margin-top: 20px;
				}

				.cooperation-item {
					background-color: #fff;
					padding: 20px;
					border-radius: 10px;
					width: calc(25% - 15px);
					cursor: pointer;
					display: flex;
					justify-content: center;

					/* 笔记本适配 */
					@media (max-width: 1440px) {
						width: calc(25% - 13.5px);
						padding: 18px;
					}

					@media (max-width: 1280px) {
						width: calc(25% - 11.25px);
						padding: 16px;
					}

					.el-image {
						width: 60%;
						height: 60px;

						/* 笔记本适配 */
						@media (max-width: 1440px) {
							height: 55px;
						}

						@media (max-width: 1280px) {
							height: 50px;
						}
					}
				}
			}
		}
	}
</style>